<template>
    <div class="container">
        <SearchCore  v-if="screenSize === 'xs' || screenSize === 'sm'" class="mv4"/>
        <InlineSearch v-else class="mv3" />
    </div>
</template>

<script>
import SearchCore from '@/components/global/SearchCore.vue';
import InlineSearch from '@/components/landing/InlineSearch.vue';

export default {
    components: {
        SearchCore,
        InlineSearch
    },
    computed: {
        screenSize() {
            return this.$mq;
        }
    }
};
</script>
